import Vue from 'vue'
import mutations from './mutations'
import categories from '@/api/categories'
import { notify } from '@/utils/error'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'categories'

function recursiveOrderUpdate (updates, categoryId, businessUnitId) {
  return new Promise((resolve, reject) => {
    const currentUpdate = updates[0]
    const remainingUpdates = updates.slice(1)
    categories.setSortOrder({ businessUnitId, categoryId, subcategoryId: currentUpdate.id, sortOrder: currentUpdate.sort_order, type: currentUpdate.type })
      .then(() => {
        if (remainingUpdates.length) {
          recursiveOrderUpdate(remainingUpdates, categoryId, businessUnitId)
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  namespaced: true,

  state: {
    items: {},
    articles: [],
    lastLevelItems: [],
    podKategorije: []
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    loadLastLevelItems ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        categories.getLastLevelItems({ businessUnitId })
          .then(response => {
            const items = response.data.items
            commit('setLastLevelItems', items)
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    getArticles ({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        categories.getArticles({ businessUnitId, id })
          .then(response => {
            const items = response.data.items
            commit('setArticles', items)
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    setSubcategories ({ state, rootState, dispatch }, { categoryId, arejPodskupin }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        const promiseLand = []
        arejPodskupin.forEach(podskupina => {
          promiseLand.push(categories.setSubcategory({ businessUnitId, categoryId, podskupina }))
        })

        Promise.all(promiseLand)
          .then((res) => {
            dispatch('getSubcategories', categoryId)
              .then(printerjiSkupine => {
                resolve(res)
              })
          })
          .catch(err => reject(err))
      })
    },
    getSubcategories ({ state, rootState, commit }, id) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        const categoryId = id
        categories.getSubcategories({ businessUnitId, categoryId })
          .then((usp) => {
            const podkategorije = usp.data && usp.data.items ? Object.values(usp.data.items) : null
            const grupaPodkategorij = { ...state.podKategorije }
            grupaPodkategorij[categoryId] = podkategorije
            commit('setElements', { type: 'podKategorije', elements: grupaPodkategorij })
            resolve(grupaPodkategorij)
          })
          .catch((err) => reject(err))
      })
    },
    deleteSubcategory ({ state, rootState, commit }, { categoryId, subcategoryId, typeId }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        categories.deleteSubcategory({ businessUnitId, categoryId, subcategoryId, typeId })
          .then(() => {
            const index = state.podKategorije[categoryId].findIndex(el => el.id === subcategoryId && el.type === typeId)
            commit('removeSubcategory', { categoryId, index })
            resolve()
          })
          .catch((err) => reject(err))
      })
    },
    updateArticlesSubcategory ({ rootState }, { updates, categoryId }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        recursiveOrderUpdate(updates, categoryId, businessUnitId)
          .then(() => {
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations,
    setLastLevelItems (store, items) {
      store.lastLevelItems = items
    },
    setArticles (store, items) {
      store.articles = items
    },
    removeSubcategory (state, { categoryId, index }) {
      Vue.delete(state.podKategorije[categoryId], index)
    }
  }
}
